module.exports = __webpack_public_path__ + "media/flags/gf-c0dcbfef.svg";